module.exports = __webpack_public_path__ + "img/client-10.2fe7b326.webp";